var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.showDialog, "max-width": _vm.maxWidth },
      on: { "click:outside": _vm.cancelClick }
    },
    [
      _c(
        "v-card",
        [
          _vm.isHtml
            ? [
                _c("v-card-title", {
                  domProps: { innerHTML: _vm._s(_vm.defaultMsg) }
                })
              ]
            : [_c("v-card-title", [_vm._v(_vm._s(_vm.defaultMsg))])],
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _vm.isConfirm
                ? _c(
                    "v-btn",
                    {
                      attrs: { depressed: "" },
                      on: { click: _vm.cancelClick }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.cancelButtonCaption) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { depressed: "", color: "primary" },
                  on: { click: _vm.okClick }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.okButtonCaption) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6690a3c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6690a3c9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/SimpleDialog.vue
// module id = ndKo
// module chunks = 1